import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  public clear(): void {
    localStorage.clear();
  }

  public getItemString(key: string): string {
    return localStorage.getItem(key);
  }

  public getItem(key: string): string {
    if (key === 'token') {
      return localStorage.getItem(key);
    }
    return JSON.parse(localStorage.getItem(key));
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public setItem(key: string, data: string): void {
    localStorage.setItem(key, data);
  }
}
